<script lang="ts">
	import { getTranslate } from "@utils/getTranslate.js";
	import { getHowItWorksAnchor } from "@core/schema/paths/getHowItWorksAnchor.js";
	import { idFromAnchor } from "@core/schema/utils/idFromAnchor.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";
	import translations from "./GiftSubscriptionHowItWorksSection.translations.json" with { type: "json" };
	import HowItWorksSection from "./HowItWorksSection.svelte";

	const { tenant } = getGlobalTemplateProps();
	const translate = getTranslate(translations);
	const id = idFromAnchor(getHowItWorksAnchor(tenant.locale));
</script>

<HowItWorksSection
	{id}
	section={translate("section")}
	title={translate("title")}
	checks={[translate("check1"), translate("check2")]}
	steps={[
		{
			title: translate("stepOneTitle"),
			description: translate("stepOneDescription"),
			class: "bg-white container-start-1 md:container-end-6 lg:container-end-3",
			textClass: "text-fcrdarkbrown",
		},
		{
			title: translate("stepTwoTitle"),
			description: translate("stepTwoDescription"),
			class: ["bg-fcrlinen", "md:container-start-7 lg:container-start-4 lg:container-end-6"],
			textClass: "text-fcrdarkbrown",
		},
		{
			title: translate("stepThreeTitle"),
			description: translate("stepThreeDescription"),
			class: ["bg-fcrbrown", "md:container-start-1 md:container-end-6 lg:container-start-7 lg:container-end-9"],
		},
		{
			title: translate("stepFourTitle"),
			description: translate("stepFourDescription"),
			class: ["bg-fcrmaroon", "md:container-start-7 md:container-end-12 lg:container-start-10 lg:container-end-12"],
		},
	]}
/>
